import get from 'lodash/get';
import translationsData from '../locales/en-us.json';
import isRealNumber from './is-real-number';
const translations = translationsData['en-us'];
const unfilledInterpolationRegex = /\{([^\{]+)\}/g;
/**
 * Returns a string using the requested path, language, and interpolations.
 *
 * @remarks
 *
 * By passing interpolations you can give variable data,
 *  keeping the correct positioning for the requested language.
 *
 * (lol, joke, As of now, this always translates into US english)
 *
 * `count` is a special interpolation, with 1 and 0 being particularly special:
 *
 * • a count of `0` will check for paths suffixed with `::none`, `::0`, and `::multiple`,
 *  in that order, before accepting the path exactly as given.
 *
 * • a count of `1` will do the same, but with suffixes of `::singular`, then `::1`.
 *
 * • any other number will check for a `::multiple` suffixed path, before the exact path.
 *
 *
 * @param translationPath - A dot delimited string describing the path to the required JSON value
 * @param interpolations - An object containing the pluralising `count`, and any other interpolations
 * @returns a string representing the value at the path requested, interpolated as requested
 */
export function getTranslation(translationPathProps, 
// Allowing count as a string means we don’t limit the usage of this
interpolations) {
    const itemCountRaw = interpolations?.count;
    const hasCount = isRealNumber(itemCountRaw);
    const itemCount = hasCount ? itemCountRaw : null;
    const translationPaths = !hasCount ? [translationPathProps]
        : itemCount === 0 ?
            [
                `${translationPathProps}::none`,
                `${translationPathProps}::0`,
                `${translationPathProps}::multiple`,
                translationPathProps,
            ]
            : itemCount === 1 ?
                [
                    `${translationPathProps}::singular`,
                    `${translationPathProps}::1`,
                    translationPathProps,
                ]
                : [
                    `${translationPathProps}::${itemCountRaw}`,
                    `${translationPathProps}::multiple`,
                    translationPathProps,
                ];
    let translatedText;
    for (let i = 0, l = translationPaths.length; i < l; i += 1) {
        translatedText = get(translations, translationPaths[i]);
        if (translatedText) {
            break;
        }
    }
    translatedText ??=
        process.env.NODE_ENV === 'production' ?
            ''
            : `[MISSING TRANSLATION: ${translationPathProps}]`;
    if (interpolations) {
        translatedText = Object.entries(interpolations).reduce((currentText, [key, value]) => currentText?.replace?.(`{${key}}`, String(value)), translatedText);
    }
    if (unfilledInterpolationRegex.test(translatedText)) {
        translatedText = translatedText.replace(unfilledInterpolationRegex, process.env.NODE_ENV === 'production' ?
            ''
            : '[UNFILLED INTERPOLATION: $1]');
    }
    return translatedText;
}
export default getTranslation;
//# sourceMappingURL=translate.js.map